var breadcrumbsI18n = {
  breadcrumbs: 'Breadcrumb'
};
export default breadcrumbsI18n;